import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { NavigationProjects } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { Budgets } from "@src/components/modules/projects/budgets";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Project Budgets`}
    navigation={<NavigationProjects projectId={id} />}
    scrollToTopButton
  >
    <Budgets id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/projects/budgets/")({
  component: RouteComponent,
});
